'use client';

import { ReactNode } from 'react';
import { usePathname } from 'next/navigation';
import { getUiConfig } from '../config/getUiConfig';
import { GlobalStyles } from '../styles/GlobalStyles';
import { CommonDataProvider } from '../common-data/useCommonData';
import { ICommonData } from '../common-data/ICommonData';
import { ConfigProvider } from '../ui';
import { getCurrentAirportCodeFromSlug } from '../components/common/navigation/utils/getCurrentAirportCode';

interface IProvidersProps {
	commonData: ICommonData;
	children: ReactNode;
}

export function Providers({ commonData, children }: IProvidersProps) {
	const pathname = usePathname();
	const currentAirport = getCurrentAirportCodeFromSlug(pathname);
	const common = { ...commonData, airportCode: currentAirport };

	return (
		<CommonDataProvider value={common}>
			<ConfigProvider config={getUiConfig(currentAirport)}>
				<GlobalStyles />
				{children}
			</ConfigProvider>
		</CommonDataProvider>
	);
}
